'use client';

import useTranslation from 'next-translate/useTranslation';
import { Text } from '@eqi-investimentos/react';
import { InstitutionsToConnectList } from '@/modules/Wallet/ui/ConnectInstitutionsModal/InstitutionsToConnectList';
import { Drawer } from '../../../../components/molecules/Drawer';
import { MODAL_CONNECTORS_ID } from '@/viewModels/InvestViewModel/utils';
export const ConnectInstitutionsModal = () => {
  const {
    t
  } = useTranslation('common');
  return <Drawer id={MODAL_CONNECTORS_ID} showIconButton={false} bodyProps={{
    p: 0,
    px: '15px'
  }} headerContent={<Text fontSize="sm" color="content.primary" fontWeight="light" lineHeight="6">
          {t('screens.myWallet.drawers.connectorsBrokers.titleAlternative')}
        </Text>} headerProps={{
    pt: '3.125rem',
    px: '3rem'
  }} closeButtonProps={{
    top: '3.1875rem',
    w: '1.5rem',
    h: '1.5rem'
  }} backButtonProps={{
    buttonProps: {
      top: '3.3125rem',
      w: '1.5rem',
      h: '1.5rem'
    }
  }} data-sentry-element="Drawer" data-sentry-component="ConnectInstitutionsModal" data-sentry-source-file="index.tsx">
      <InstitutionsToConnectList data-sentry-element="InstitutionsToConnectList" data-sentry-source-file="index.tsx" />
    </Drawer>;
};